<template>
  <div>
    <label class="lg">
      {{ __('Tokens Privados') }}
    </label>
    <a
      class="float-right"
      href="#"
      @click.prevent="showCreateTokenForm"
      style="font-weight: 600;"
    >
      {{ __('Novo Token') }}
    </a>
    <p
      class="form-text"
      v-if="tokens.length === 0"
    >
      {{ __('Você não possui nenhum token privado') }}.
    </p>
    <ul
      class="list-group question-sortable"
      v-else
    >
      <li
        class="list-group-item d-flex align-items-center"
        v-for="token in tokens"
      >
        <span>
          {{ token.name }}
        </span>
        <span class="ml-auto">
          <SalesflowTrash 
            class="icon-trash"
            @click.native.prevent="showDeleteTokenModal(token)"
          />
        </span>
      </li>
    </ul>
    <!-- Create Token Modal-->
    <BModal
      id="modal-create-token"
      ref="modal-create-token"
      hide-footer
      centered
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Novo Token') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['modal-create-token'].hide()"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <!-- Form Errors-->
        <div
          class="alert alert-danger"
          v-if="form.errors.length > 0"
        >
          <ul>
            <li v-for="error in form.errors">
              {{ error }}
            </li>
          </ul>
        </div>
        <form
          class="form-horizontal"
          role="form"
          @submit.prevent="store()"
        >
          <div class="form-group">
            <label>{{ __('Nome') }}</label>
            <input
              class="form-control"
              id="create-token-name"
              type="text"
              name="name"
              v-model="form.name"
            >
          </div>
          <div
            class="form-group"
            v-if="scopes.length > 0"
          >
            <label>Scopes</label>
            <div v-for="scope in scopes">
              <div class="checkbox">
                <label>
                  <input
                    type="checkbox"
                    @click="toggleScope(scope.id)"
                    :checked="scopeIsAssigned(scope.id)"
                  >{{ scope.id }}
                </label>
              </div>
            </div>
          </div>
          <div class="modal-footer default-modal-footer pt-2">
            <button
              class="button cancel"
              type="button"
              :disabled="form.saving"
              @click.prevent="$refs['modal-create-token'].hide()"
            >
              Cancelar
            </button>
            <button
              class="button save"
              type="submit"
              :disabled="form.saving"
            >
              <span v-if="form.saving">{{ __('Salvando') }}...</span><span v-else>{{ __('Salvar') }}</span>
            </button>
          </div>
        </form>
      </template>
    </BModal>
    <!-- Access Token Modal-->
    <BModal
      id="modal-access-token"
      ref="modal-access-token"
      modal-class="modal-access-token"
      hide-footer
      centered
    >
      <template slot="modal-header">
        <div class="modal-title">
          {{ __('Novo Token') }}
        </div>
        <button
          class="close"
          type="button"
          data-dismiss="modal"
          aria-label="Close"
          @click="$refs['modal-access-token'].hide()"
        >
          <span aria-hidden="true"><img
            class="mb-5px"
            src="/build/icons/close@white.svg"
            width="14"
            height="13"
          ></span>
        </button>
      </template>
      <template slot="default">
        <p class="form-text">
          {{ __('Aqui está seu novo token privado') }}
        </p>
        <p class="form-text">
          {{ __('Copie seu token privado e cole em um local seguro.') }}
        </p>
        <p>
          <b>{{ __('Ele será exibido somente desta vez.') }}</b>
        </p>
        <div class="input-token" id="private-token">
          <span id="private-token">
            {{ accessToken }}
          </span>
          <img
            src="/build/icons/files.svg"
            @click="selectText('private-token')" 
          />
        </div>
        <div class="modal-footer default-modal-footer">
          <button
            class="button conclude"
            type="button"
            @click.prevent="$refs['modal-access-token'].hide()"
          >
            {{ __('Concluir') }}
          </button>
        </div>
      </template>
    </BModal>
    <!-- Delete Token Modal -->
    <BModal 
      id="modal-delete-token"
      ref="modal-delete-token"
      modal-class="modal-delete-token"
      hide-footer
      hide-header
      centered
    >
      <SalesflowTriangleExclamationRounded />
      <p>{{ __('Deseja excluir este token privado?') }}</p>
      <span>{{ __('Todas as integrações realizadas por este token serão perdidas') }}</span>
      <div class="button-group">
        <button
          class="button cancel"
          type="button"
          @click="$refs['modal-delete-token'].hide()"
        >
          {{ __('Cancelar') }}
        </button>
        <button
          class="button save"
          type="button"
          @click="deleteToken"
        >
          <span v-if="deleting">{{ __('Excluindo') }}...</span><span v-else>{{ __('Excluir') }}</span>
        </button>
      </div>
    </BModal>
  </div>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import SalesflowTrash from '../../components/icon/SalesflowTrash.vue';
import SalesflowTriangleExclamationRounded from '../../components/icon/SalesflowTriangleExclamationRounded.vue'

export default {
  components: {
    BModal,
    SalesflowTrash,
    SalesflowTriangleExclamationRounded
  },

  /*
     * The component's data.
     */
  data () {
    return {
      accessToken: null,

      tokens: [],
      scopes: [],
      tokenToDelete: null,
      deleting: false,

      form: {
        saving: false,
        name: '',
        scopes: [],
        errors: [],
      },
    };
  },

  /**
     * Prepare the component (Vue 1.x).
     */
  ready () {
    this.prepareComponent();
  },

  /**
     * Prepare the component (Vue 2.x).
     */
  mounted () {
    this.prepareComponent();
  },

  methods: {
    async selectText(id) {
      const span = document.getElementById(id);
      const text = span.innerText || span.textContent;

      try {
        await navigator.clipboard.writeText(text);
        Alert.success(this.__('Token copiado'));
      } catch (err) {
        Alert.error(this.__('Erro ao copiar o token'));
      }
    },

    /**
       * Prepare the component.
       */
    prepareComponent () {
      this.getTokens();

      this.$root.$on('bv::modal::show', (event, modalId) => {
        if (modalId == 'modal-create-token') {
          document.querySelector('create-token-name').focus();
        }
      });
    },

    /**
       * Get all of the personal access tokens for the user.
       */
    getTokens () {
      this.$http.get('/oauth/personal-access-tokens')
        .then((response) => {
          this.tokens = response.data;
        });
    },

    /**
       * Get all of the available scopes.
       */
    getScopes () {
      this.$http.get('/oauth/scopes')
        .then((response) => {
          this.scopes = response.data;
        });
    },

    /**
       * Show the form for creating new tokens.
       */
    showCreateTokenForm () {
      this.$refs['modal-create-token'].show();
    },

    /**
       * Create a new personal access token.
       */
    store () {
      this.accessToken = null;

      this.form.errors = [];
      this.form.saving = true;

      this.$http.post('/oauth/personal-access-tokens', this.form)
        .then(({ data }) => {
          this.form.name = '';
          this.form.scopes = [];
          this.form.errors = [];

          this.tokens.push(data.token);
          this.showAccessToken(data.accessToken);
        })
        .catch((error) => {
          if (typeof error.response.data === 'object') {
            this.form.errors = _.flatten(_.toArray(error.response.data));
          } else {
            this.form.errors = ['Something went wrong. Please try again.'];
          }
        })
        .finally(() => {
          this.form.saving = false;
        });
    },

    /**
       * Toggle the given scope in the list of assigned scopes.
       */
    toggleScope (scope) {
      if (this.scopeIsAssigned(scope)) {
        this.form.scopes = _.reject(this.form.scopes, (s) => s == scope);
      } else {
        this.form.scopes.push(scope);
      }
    },

    /**
       * Determine if the given scope has been assigned to the token.
       */
    scopeIsAssigned (scope) {
      return _.indexOf(this.form.scopes, scope) >= 0;
    },

    /**
       * Show the given access token to the user.
       */
    showAccessToken (accessToken) {
      this.$refs['modal-create-token'].hide();

      this.accessToken = accessToken;

      this.$refs['modal-access-token'].show();
    },

    showDeleteTokenModal(token) {
      this.tokenToDelete = token;
      this.$refs['modal-delete-token'].show();
    },

    deleteToken() {
      if (!this.tokenToDelete) return;
      this.deleting = true;
      const tokenId = this.tokenToDelete.id;

      this.$http.delete(`/oauth/personal-access-tokens/${tokenId}`)
        .then((response) => {
          const index = this.tokens.findIndex(token => token.id === tokenId);
          this.tokens.splice(index, 1);
          Alert.success(this.__('Token removido com sucesso'));
        })
        .catch(() => {
          Alert.error(this.__('Erro ao remover o token'));
        })
        .finally(() => {
          this.deleting = false;
          this.tokenToDelete = null;
          this.$refs['modal-delete-token'].hide();
        })
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.list-group-item {
  border: 1px solid #D1D1D1;
  padding: 16px;

  span {
    font-weight: 500;
  }
}

.list-group-item:first-child {
  border-radius: 8px 8px 0 0;
}

.list-group-item:last-child {
  border-radius: 0 0 8px 8px;
}

.list-group-item:only-child {
  border-radius: 8px;
}

.icon-trash {
  cursor: pointer;
}

::v-deep .modal-content {
  border: none;
  width: 415px;
}

::v-deep .modal-header {
  border-radius: 16px 16px 0 0;
}

::v-deep .modal-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 0 0 16px 16px;
  background: #F5F5F5;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);
  padding: 24px;
}

::v-deep .modal-footer {
  background: none;
  padding: 0;
}

::v-deep .modal-access-token .modal-content {
  width: 509px;
}

.form-control {  
  border-radius: 8px;
  border: 1px solid  #D1D1D1;
  background: #FFF;
  padding: 13px 12px;
}

.button {
  border-radius: 14px;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
}

.button.cancel {
  border: 1px solid #886AF8;
  color: #886AF8;
  padding: 12px 18px;
}

.cancel:hover {
  color: #FFF;
  border-color: #5F33FF;
  background-color: #5F33FF;
}

.button.save {
  border: 1px solid #2CEBA9;
  background: #2CEBA9;
  color: #242424;
  padding: 12px 32px;
}

.save:hover {
  color: #FFF;
  border-color: #1DC38A;
  background: #1DC38A;
}

.input-token {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
  gap: 8px;
  border-radius: 8px;
  padding: 16px 12px;
  border: 1px solid #D1D1D1;
  background: rgba(226, 232, 240, 0.40);
  color: #242424;
  box-sizing: border-box;
  
  span {
    flex-grow: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: Montserrat;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
  }

  img {
    flex-shrink: 0;
    cursor: pointer;
  }
}

.button.conclude {
  padding: 12px 32px;
  border-radius: 14px;
  border: 1px solid #2CEBA9;
  background: #2CEBA9;
  margin-top: 8px;
}

.conclude:hover {
  color: #FFF;
  border-color: #1DC38A;
  background: #1DC38A;
}

::v-deep .modal-delete-token .modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 448px;
  padding: 56px 48px;
  gap: 24px;
  border-radius: 16px;
  background: #F5F5F5;
  box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.10);

  p {
    margin-bottom: 0;
    color: #242424;
    text-align: center;
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }
}

::v-deep .modal-delete-token .modal-body > span {
  color: #71767D;
  text-align: center;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.button-group {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
